var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 1.85715C14.9505 1.85715 16.8211 2.63197 18.2003 4.01117C19.5795 5.39036 20.3543 7.26095 20.3543 9.21143C20.3543 17.3886 23.3372 19 24.1429 19H1.85718C2.68003 19 5.64575 17.3714 5.64575 9.21143C5.64575 7.26095 6.42057 5.39036 7.79977 4.01117C9.17897 2.63197 11.0496 1.85715 13 1.85715V1.85715Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell_icon.892faf644d9661e19153dc17f8f48f27.svg";